<template>
    <!-- PC version disabled -->
    <!-- <div class="rel disabled-on-mobile" :class="{ excluded: item.excluded }">
        <li class="nav-item">
            <router-link class="nav-link" :to="item.link" :class="{ disabled: item.disabled }"
                @click="sidebarCollapse()" @mouseover="showSubNav = true" @mouseleave="handleMouseLeave">
                <i :class="'bi bi-' + item.icon + ' special-icon'"></i> <span class="nav-text">{{ item.text }}</span>
                <span class="badge ms-1 rounded-pill bg-danger" v-if="item.badge === 'inbox-unread'">
                    {{ inboxCountData }}
                    <span class="visually-hidden">unread claims</span>
                </span>
                <span class="badge ms-1 rounded-pill bg-danger" v-if="item.badge === 'outbox'">
                    {{ outboxCountData }}
                    <span class="visually-hidden">outbox claims</span>
                </span>
                <i v-if="item.sub && item.sub.length" class="bi bi-chevron-right bi-sm chevron-right"></i>
            </router-link>
            <div @mouseover="showSubNavHover = true" @mouseleave="handleMouseLeaveSubNav" class="sub-nav-container rel" v-if="item.sub && item.sub.length && (showSubNav || showSubNavHover)">
                <ul class="nav sub" @click="sidebarCollapse()">
                    <sidebar-child v-for="(subItem, index) in item.sub"
                    :key="index" :item="subItem" :inboxCount="inboxCountData " :outboxCount="outboxCountData"></sidebar-child>
                </ul>
            </div>
        </li>
    </div> -->

    <!-- PC version -->
    <div :id="item.slug + '-tab'" class="rel disabled-on-mobile width-100" :class="{ excluded: item.excluded }">
        <li class="nav-item">
            <router-link v-if="!item.sub || !item.sub.length" :to="item.link" class="nav-link pd-left-2" :class="{ disabled: item.disabled }"
                @click="sidebarHide()">
                <i :class="'bi bi-' + item.icon + ' special-icon'"></i> <span class="nav-text">{{ item.text }}</span>
                <span class="badge ms-1 rounded-pill bg-danger" v-if="item.badge === 'inbox-unread'">
                    {{ inboxCountData }}
                    <span class="visually-hidden">unread claims</span>
                </span>
                <span class="badge ms-1 rounded-pill bg-danger" v-if="item.badge === 'outbox'">
                    {{ outboxCountData }}
                    <span class="visually-hidden">outbox claims</span>
                </span>
            </router-link>
            <button v-else type="button" class="nav-link pd-left-2 mb-0" :class="{ disabled: item.disabled }" :aria-expanded="showSubNav"
                @click="hideIfHasSubs($event)">
                <i :class="'bi bi-' + item.icon + ' special-icon'"></i> <span class="nav-text">{{ item.text }}</span>
                <span class="badge ms-1 rounded-pill bg-danger" v-if="item.badge === 'inbox-unread'">
                    {{ inboxCountData }}
                    <span class="visually-hidden">unread claims</span>
                </span>
                <span class="badge ms-1 rounded-pill bg-danger" v-if="item.badge === 'outbox'">
                    {{ outboxCountData }}
                    <span class="visually-hidden">outbox claims</span>
                </span>
            </button>
            <button v-if="item.sub && item.sub.length" type="button" class="chevron-toggle" :aria-label="item.text" :aria-expanded="showSubNav" @click="toggleVisibility($event)"><i class="bi bi-chevron-right bi-sm chevron-right" aria-hidden="true"></i></button>
            <div class="sub-nav-container rel" v-if="item.sub && item.sub.length">
                <ul class="nav sub">
                    <sidebar-child v-for="(subItem, index) in item.sub" @sidebarHide="sidebarHide"
                    :key="index" :item="subItem" :inboxCount="inboxCountData " :outboxCount="outboxCountData"></sidebar-child>
                </ul>
            </div>
        </li>
    </div>

    <!-- Mobile version -->
    <div :id="item.slug + '-tab-mobile'" class="rel disabled-on-pc width-100" :class="{ excluded: item.excluded }">
        <li class="nav-item">
            <router-link v-if="!item.sub || !item.sub.length" :to="item.link" class="nav-link pd-left-2" :class="{ disabled: item.disabled }"
                @click="sidebarHide()">
                <i :class="'bi bi-' + item.icon + ' special-icon'"></i> <span class="nav-text">{{ item.text }}</span>
                <span class="badge ms-1 rounded-pill bg-danger" v-if="item.badge === 'inbox-unread'">
                    {{ inboxCountData }}
                    <span class="visually-hidden">unread claims</span>
                </span>
                <span class="badge ms-1 rounded-pill bg-danger" v-if="item.badge === 'outbox'">
                    {{ outboxCountData }}
                    <span class="visually-hidden">outbox claims</span>
                </span>
            </router-link>
            <button v-else type="button" class="nav-link pd-left-2 mb-0" :class="{ disabled: item.disabled }" :aria-expanded="showSubNav"
                @click="hideIfHasSubs($event)">
                <i :class="'bi bi-' + item.icon + ' special-icon'"></i> <span class="nav-text">{{ item.text }}</span>
                <span class="badge ms-1 rounded-pill bg-danger" v-if="item.badge === 'inbox-unread'">
                    {{ inboxCountData }}
                    <span class="visually-hidden">unread claims</span>
                </span>
                <span class="badge ms-1 rounded-pill bg-danger" v-if="item.badge === 'outbox'">
                    {{ outboxCountData }}
                    <span class="visually-hidden">outbox claims</span>
                </span>
            </button>
            <button v-if="item.sub && item.sub.length" type="button" class="chevron-toggle" :aria-label="item.text" :aria-expanded="showSubNav" @click="toggleVisibility($event)"><i class="bi bi-chevron-right bi-sm chevron-right" aria-hidden="true"></i></button>
            <div class="sub-nav-container rel" v-if="item.sub && item.sub.length">
                <ul class="nav sub">
                    <sidebar-child v-for="(subItem, index) in item.sub" @sidebarHide="sidebarHide"
                    :key="index" :item="subItem" :inboxCount="inboxCountData " :outboxCount="outboxCountData"></sidebar-child>
                </ul>
            </div>
        </li>
    </div>
</template>

<script>
import axios from 'axios';
import { rates } from '../../libs/rate'
export default {
    name: 'SidebarChild',
    props: {
        item: {
            type: Object,
            required: true
        },
        inboxCount: {
            type: Number,
            required: true
        },
        outboxCount: {
            type: Number,
            required: true
        }
    },
    data: () => ({
        sidebarShow: false,
        outboxCountData: 0,
        inboxCountData: 0,
        showSubNav: false,
        showSubNavHover: false,
        currentPlan: {}
    }),
    watch: {
        outboxCount: {
            immediate: true,
            handler(val) {
                this.outboxCountData = val
            }
        },
        inboxCount: {
            immediate: true,
            handler(val) {
                this.inboxCountData  = val
            }
        }
    },
    methods: {
        getInboxCount() {
            let url = process.env.VUE_APP_API_URL + '/claims/inbox-count';
            axios.get(url, { withCredentials: true })
                .then(response => {
                    let r = response.data;
                    if (r.result === 'SUCCESS') {
                        if(r.data >= 0) this.inboxCount = r.data;
                        this.$emit('updatedInboxCount', this.inboxCount);
                    } else {
                        this.$notify({
                            title: this.$t('notify.types.error'),
                            text: 'Не удалось проверить количество входящих' + r.message,
                            type: 'error'
                        });
                    }
                });
        },
        getOutboxCount() {
            let url = process.env.VUE_APP_API_URL + '/claims/outbox-count';
            axios.get(url, { withCredentials: true })
                .then(response => {
                    let r = response.data;
                    if (r.result === 'SUCCESS') {
                        if(r.data >= 0) this.outboxCount = r.data
                        this.$emit('updatedOutboxCount', this.outboxCount);
                    } else {
                        this.$notify({
                            title: this.$t('notify.types.error'),
                            text: 'Не удалось проверить количество исходящих' + r.message,
                            type: 'error'
                        });
                    }
                });
        },
        sidebarCollapse() {
            //collapse sidebar sub elements
            this.handleMouseLeave()
            this.handleMouseLeaveSubNav()
        },
        sidebarHide() {
            //hide sidebar on mobile
            this.$emit('sidebarHide');
        },
        hideIfHasSubs(event) {
            this.toggleVisibility(event)

        },
        toggleVisibility(eventOrIndex) {
            let clickedIcon

            if (typeof eventOrIndex === 'number') {
                const allIcons = Array.from(document.querySelectorAll('.chevron-right'))
                    .filter(el => el.offsetParent !== null) // only visible ones
                clickedIcon = allIcons[eventOrIndex]
            } else if (eventOrIndex?.target) {
                const event = eventOrIndex
                const row = event.target.closest('.nav-item')
                clickedIcon = row?.querySelector(':scope > .chevron-toggle')
            } else {
                console.warn('Invalid argument', eventOrIndex)
                return
            }

            if (!clickedIcon) return

            const parentSubNavContainer = clickedIcon.closest('.sub-nav-container')
            const subNavContainer = clickedIcon.nextElementSibling
            const iconElement = clickedIcon.querySelector('.chevron-right')
            const allIconElements = document.querySelectorAll('.chevron-right')
            const allSubNavs = document.querySelectorAll('.sub-nav-container')

            const isOpen = subNavContainer?.classList.contains('visible')

            if (isOpen) {
                subNavContainer.classList.remove('visible')
                iconElement?.classList.remove('rotate-180')
            } else {
                allSubNavs.forEach(el => el.classList.remove('visible'))
                allIconElements.forEach(el => el.classList.remove('rotate-180'))

                if (subNavContainer) {
                    subNavContainer.classList.add('visible')
                }
                    iconElement?.classList.add('rotate-180')
            }

            //making sure parent element is not affected, as well as it's sibling icon
            if (parentSubNavContainer) {
                parentSubNavContainer.classList.toggle('visible')
                parentSubNavContainer.previousElementSibling?.classList.add('rotate-180')
            }
        },
        handleMouseLeave() {
            // Delay hiding to allow for smooth transition
            setTimeout(() => {
                this.showSubNav = false
            }, 20);
        },
        handleMouseLeaveSubNav() {
            // Delay hiding to allow for smooth transition
            setTimeout(() => {
                this.showSubNavHover = false
            }, 20)
        },
        async getCurrentPlan() {
                let url = process.env.VUE_APP_API_URL + '/rates/get-current-plan'

                await axios.get(url, {
                    withCredentials: true
                }).then((response) => {
                    let r = response.data

                    if(r.result === 'SUCCESS') {
                        this.currentPlan = r.data
                        if(this.currentPlan.id !== rates.enterprise && this.item.link == '/claims/import') { // if not enterprise
                            this.item.excluded = true
                        }
                    } else {
                        this.item.exluded = true
                    }
                })
            }
    },
    mounted() {
        // this.getInboxCount()
        // this.getOutboxCount()
        this.getCurrentPlan()

        this.$emit("exposeToggle", this.toggleVisibility)
    }
};
</script>

<style scoped>
    .rel {
        position: relative;
        width: -webkit-fill-available;
    }

    .excluded { 
        display: none !important;
    }

    p.mb-0 {
        margin-bottom: 0 !important;
    }

    .width-100 {
        width: 100%;
    }

    .disabled-on-pc {
        display: none;
    }

    .disabled-on-mobile {
        display: block;
    }

    .nav-item {
        cursor: pointer;
    }

    .nav-link,
    .btn-link {
        display: flex;
        align-items: center;
        gap: 10px;
        width: 100%;
        min-height: 42px;
        padding: 9px 44px 9px 12px;
        color: #e0def2;
        background: transparent;
        border: 1px solid transparent;
        border-radius: var(--kdp-radius-md);
        text-decoration: none;
        font-size: var(--kdp-font-size-sm);
        font-weight: var(--kdp-font-weight-medium);
        line-height: var(--kdp-line-height-snug);
        position: relative;
        transition: color .18s ease, background-color .18s ease, border-color .18s ease, box-shadow .18s ease;
    }

    .nav-text {
        min-width: 0;
        overflow-wrap: anywhere;
    }

    .nav-link .bi,
    .btn-link .bi {
        flex: 0 0 22px;
        color: #958dff;
        font-size: 1.18rem;
        line-height: var(--kdp-line-height-tight);
    }

    .nav-link:hover,
    .btn-link:hover,
    .nav-item:hover > .nav-link {
        color: var(--kdp-white);
        background: rgba(166, 160, 251, .12);
        border-color: rgba(166, 160, 251, .2);
    }

    .nav-item:hover > .nav-link .bi {
        color: var(--kdp-white);
    }

    .nav-link:focus,
    .btn-link:focus,
    #app .btn-link:active {
        color: var(--kdp-white);
        background: rgba(255, 255, 255, .1);
        border-color: #b9b4ff;
        box-shadow: 0 0 0 .2rem rgba(145, 167, 255, .16);
        outline: 0;
    }

    .nav-link.router-link-active {
        color: var(--kdp-white);
        background: rgba(166, 160, 251, .2);
        border-color: rgba(166, 160, 251, .34);
        box-shadow: inset 3px 0 0 var(--kdp-primary);
        font-weight: var(--kdp-font-weight-bold);
    }

    .nav-link.router-link-active .bi {
        color: var(--kdp-white);
    }

    .nav-link.disabled {
        color: rgba(217, 222, 238, .42);
        pointer-events: none;
    }

    .nav-link.disabled .bi {
        color: rgba(145, 167, 255, .36);
    }

    .badge {
        margin-left: auto !important;
        background: #ef4444 !important;
        border: 1px solid rgba(255, 255, 255, .22);
        font-size: .68em;
        font-weight: var(--kdp-font-weight-bold);
    }

    .chevron-right {
        position: absolute;
        right: 14px;
        top: 21px;
        color: #9caaf2;
        font-size: var(--kdp-font-size-xs);
        line-height: var(--kdp-line-height-tight);
        cursor: pointer;
        transform: translateY(-50%);
        transition: color .18s ease, transform .22s ease;
        z-index: 1;
    }

    .chevron-toggle {
        position: absolute;
        top: 0;
        right: 0;
        width: 44px;
        height: 42px;
        padding: 0;
        color: inherit;
        background: transparent;
        border: 0;
        z-index: 2;
    }

    .chevron-right:hover {
        color: var(--kdp-white);
    }

    .rotate-180 {
        transform: translateY(-50%) rotate(90deg) !important;
    }

    .sub-nav-container {
        display: none;
        margin: 5px 0 7px 18px;
        padding: 6px 0 6px 12px;
        background: rgba(255, 255, 255, .045);
        border-left: 1px solid rgba(145, 167, 255, .22);
        border-radius: 0 8px 8px 0;
        transition: opacity .22s ease;
        width: auto;
        z-index: 9999;
    }

    .sub-nav-container.visible {
        display: block;
        opacity: 1;
    }

    .sub-nav-container .nav-link,
    .sub-nav-container .btn-link {
        min-height: 36px;
        padding-top: var(--kdp-space-2);
        padding-bottom: var(--kdp-space-2);
        color: #e0def2;
        font-size: .84rem;
    }

    .sub-nav-container .nav-link .bi,
    .sub-nav-container .btn-link .bi {
        color: #958dff;
        font-size: var(--kdp-font-size-base);
    }

    .sub-nav-container .sub-nav-container {
        margin-left: 14px;
        background: rgba(255, 255, 255, .035);
    }

    @media (max-width: 767px) {
        .disabled-on-pc {
            display: block;
        }

        .disabled-on-mobile {
            display: none;
        }

        .sub-nav-container {
            margin: 5px 0 8px 20px;
        }

        .nav-link,
        .btn-link {
            min-height: 44px;
        }
    }
</style>
